import type { FormSection } from "../sections"

import { useFieldStore } from "@versatile-credit-apply/sdk"
import type { ApplicationFieldPath } from "@versatile-credit-apply/omni-apply-client"

type UseSectionShouldRender = (section: FormSection) => boolean

export const useSectionShouldRender = (): UseSectionShouldRender => {
  const fieldStore = useFieldStore()

  const hasFields = (fields: string[]): boolean =>
    fields.filter(
      (field) => !!fieldStore.fieldByPath(field as ApplicationFieldPath)
    ).length > 0

  return ({ fields }) => hasFields(fields)
}
